import * as types from './actionTypes';

export function addError(error) {
  return {type: types.ADD_ERROR, error};
}

export function removeError() {
  return {type: types.REMOVE_ERRORS};
}



/** WEBPACK FOOTER **
 ** ./src/actions/errorActions.js
 **/